import { FC } from 'react'
import { Button, BUTTON_TYPES } from 'components/Button'
import { IContractHealthSystem } from 'features/ContractDetails/Facilities/types'
import { fileNameFormatter } from 'helper/common'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'

type Props = Pick<IContractHealthSystem, 'amendment_document'>

const AmendmentCell: FC<Props> = (props) => {
  const { amendment_document } = props

  const handleClickLink = () => {
    if (amendment_document) {
      window.open(amendment_document)
    }
  }

  if (!amendment_document) {
    return null
  }

  const filename = fileNameFormatter(amendment_document)

  return (
    <Tooltip title={filename}>
      <Button type={BUTTON_TYPES.LINK} onClick={handleClickLink}>
        {filename}
      </Button>
    </Tooltip>
  )
}

export default AmendmentCell
